/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A7Inputs */

const en_fc_home_faq_a7 = /** @type {(inputs: Fc_Home_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the official ArtCraft website or the FilmCraft GitHub releases linked in our download guide. Check the published checksums when available, review release notes and back up your projects before trying a new build. GetFilmCraft is an independent guide, not the software publisher.`)
};

/**
* | output |
* | --- |
* | "Use the official ArtCraft website or the FilmCraft GitHub releases linked in our download guide. Check the published checksums when available, review release..." |
*
* @param {Fc_Home_Faq_A7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a7 = /** @type {((inputs?: Fc_Home_Faq_A7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a7(inputs)
});
export { fc_home_faq_a7 as "fc.home.faq.a7" }